/* eslint-disable react-hooks/exhaustive-deps */
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  SelectChangeEvent,
  Tooltip,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../../api/api";
import {
  CustomFormLabel,
  CustomSelect,
  CustomTextField,
  CustomTypography,
} from "../../../../components/formsComponents";
import { useAuth } from "../../../../contexts/AuthProvider/AuthProvider";
import { useMessagesPopup } from "../../../../contexts/MessagesPopupProvider/MessagesPopupProvider";
import {
  fetchFaultNameAsync,
  fetchFaultSubTypeAsync,
  fetchFaultTypeAsync,
  fetchStateAsync,
} from "../../../../redux/common/commonAction";
import {
  closeLoaderWithMessage,
  openLoaderWithMessage,
} from "../../../../redux/messages/messagesActions";
import { IState } from "../../../../redux/common/types";
import { IStoreState } from "../../../../redux/initialStoreState";
import { IComplaintLogProps, IVehicleList } from "./interfaces/IComplaintLog";

import { ILocationResponsePayload, LocationAutoComplete } from "../../../../components/formsComponents/LocationAutoComplete";
import { LocationOn } from "@mui/icons-material";
import { IAddressDetails, MapPicker } from "../../../../components/MapPicker/MapPicker";
import { FileUpload } from "../../../../components/FileUpload/FileUpload";
import { formatDate } from "../../../../helpers";

const vehicleType = "FOUR_WHEELER";

export const ComplaintLog: React.FC<IComplaintLogProps> = (props) => {
  const {
    selectedMemberShip,
    selectedMobileNumber,
    selectedVechileNumber,
    isFamilyPlan,
    vehicleNo,
  } = props;

  const { showSuccessMessage, showTopErrorSnackbar } = useMessagesPopup();
  const [loading, setLoading] = React.useState(false);
  const [isOtherFault, setIsOtherFault] = React.useState(false);
  const [selectedLocation, setSelectedLocation] = React.useState<string | null>(null);
  const [mapPickerOpen, setMapPickerOpen] = React.useState(false);
  const auth = useAuth();
  const [vehicleList, setVehicleList] = React.useState<IVehicleList[]>([]);
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue,
  } = useFormik({
    initialValues: {
      membership_id_v: selectedMemberShip.membership_code,
      vehicle_no_v: selectedMemberShip.vehicle_number,
      reg_contact_no_v: selectedMemberShip.contact_number,
      package_city_v: selectedMemberShip.city,
      service_state_v: "",
      partner_id_v: selectedMemberShip.partner_id,
      fault_type_v: "-1",
      fault_v: "-1",
      sub_fault_v: "-1",
      alternate_contact_no_v: "",
      area_v: selectedMemberShip.area,
      complaint_address_v: "",
      stuckup_location_v: "",
      remark_v: "",
      latitude_v: "",
      longitude_v: "",
      other_sub_fault_v: "",
      type_v: "complaint",
      vehicle_type_v: "-1",
      complaint_creation_image_v: "",
    },
    validate: (values) => {
      const errors: any = {};
      if (values.vehicle_type_v === "-1") {
        errors.vehicle_type_v = "*Vehicle type is required";
      }
      if (values.fault_type_v === "-1") {
        errors.fault_type_v = "*Fault type is required";
      } else if (values.fault_v === "-1") {
        errors.fault_v = "*Fault type is required";
      } else if (values.sub_fault_v === "-1") {
        errors.sub_fault_v = "*Field is required";
      } else if (values.stuckup_location_v === "") {
        errors.stuckup_location_v = "*Stuckup location is required";
      } else if (values.stuckup_location_v && /[^a-zA-Z0-9\s,]/.test(values.stuckup_location_v.trim())) {
        errors.stuckup_location_v = "*Stuckup location can only contain letters, numbers, spaces and comma (no other special symbols)";
      } else if (values.service_state_v === "") {
        errors.service_state_v = "*State is required";
      } else if (values.package_city_v === "") {
        errors.package_city_v = "*City is required";
      } else if (values.area_v === "") {
        errors.area_v = "*Area is required";
      }
      else if (values.remark_v === "") {
        errors.remark_v = "*Remark is required";
      }
      return errors;
    },
    onSubmit: async (values) => {
      if (auth.user && auth.user.tokens) {
        try {
          setLoading(true);
          const res = await api.post(
            "/service-booking-request-detail",
            {
              ...values,
              sub_fault_v: isOtherFault
                ? values.other_sub_fault_v
                : values.sub_fault_v,
            },
            {
              headers: {
                "auth-Token": auth.user.tokens.access,
              },
            }
          );
          showSuccessMessage(
            <>
              <Box sx={{ width: "100%" }}>
                Complaint is registered successfully!!
              </Box>
              <CustomTypography variant="body2">
                Registered Complaint Number : {res.data.complaint_no}
              </CustomTypography>
            </>
          );
          setValues({
            ...values,
            fault_type_v: "-1",
            fault_v: "-1",
            sub_fault_v: "-1",
            vehicle_type_v: "-1",
            alternate_contact_no_v: "",
            area_v: selectedMemberShip.area,
            stuckup_location_v: "",
            remark_v: "",
            complaint_creation_image_v: "",
          });
          console.log(res);
        } catch (err: any) {
          const errMsg = err.response?.data?.message || err.response?.data?.msg || err.response?.data?.error || err.message || "Failed to register complaint";
          showTopErrorSnackbar(errMsg);
        } finally {
          setLoading(false);
        }
      }
    },
  });

  const handleFileUpload = async (file: File) => {
    try {
      if (auth.user && auth.user.tokens) {
        dispatch(openLoaderWithMessage("Uploading file, please wait..."));
        const formdata = new FormData();
        formdata.append("file", file);
        const res = await api.post("/upload-docs", formdata, {
          headers: {
            "auth-Token": auth.user.tokens.access,
          },
        });
        const fileUrl = res.data.fileUrl || res.data.Location || res.data.Key || "";
        setFieldValue("complaint_creation_image_v", fileUrl);
        showSuccessMessage("File uploaded successfully");
      }
    } catch (error) {
      showTopErrorSnackbar("Failed to upload file");
    } finally {
      dispatch(closeLoaderWithMessage());
    }
  };

  const handleFileDelete = () => {
    setFieldValue("complaint_creation_image_v", "");
    showSuccessMessage("File removed successfully");
  };

  const handleAlternateMobileNumberChange = (event: any) => {
    const { value } = event.target;
    const maxLength = 10;

    // Allow empty value or digits only
    const number = /^[0-9\b]+$/;
    if (value === "" || (number.test(value) && value.length <= maxLength)) {
      setFieldValue("alternate_contact_no_v", value);
    }
  };
  const faultType = useSelector((state: IStoreState) => state.common.faultType);

  const faultName = useSelector((state: IStoreState) => state.common.faultName);
  const faultSubTypeName = useSelector(
    (state: IStoreState) => state.common.subFaultName
  );
  const dispatch = useDispatch<any>();
  const [autoField, setAutoField] = React.useState<{
    state: IState | null;
  }>({
    state: null,
  });
  const { state } = useSelector((storeState: IStoreState) => storeState.common);

  React.useEffect(() => {
    dispatch(fetchFaultTypeAsync(vehicleType));
  }, [dispatch, vehicleType, values.vehicle_no_v]);

  const handleFaultType = (e: SelectChangeEvent<unknown>) => {
    const type = e.target.value as string;
    setValues({
      ...values,
      fault_type_v: type,
      fault_v: "-1",
      sub_fault_v: "-1",
    });
    dispatch(fetchFaultNameAsync(vehicleType, type));
  };

  const handleFaultName = (e: SelectChangeEvent<unknown>) => {
    const value = e.target.value as string;
    setValues({
      ...values,
      fault_v: value,
      sub_fault_v: "-1",
    });
    dispatch(fetchFaultSubTypeAsync(vehicleType, values.fault_type_v, value));
  };


  const handleMapPickerLocationSelect = (_place: any, addressDetails?: IAddressDetails) => {
    if (addressDetails) {
      setFieldValue("stuckup_location_v", addressDetails.address || "");
      setFieldValue("service_state_v", addressDetails.state || "");
      setFieldValue("package_city_v", addressDetails.city || "");
      setFieldValue("area_v", addressDetails.area || "");
      setFieldValue("latitude_v", addressDetails.latitude != null ? String(addressDetails.latitude) : "");
      setFieldValue("longitude_v", addressDetails.longitude != null ? String(addressDetails.longitude) : "");
      setAutoField((prev) => ({ ...prev, state: null }));
      setSelectedLocation(addressDetails.address || null);
    }
    setMapPickerOpen(false);
  };


  const handleCustomerAddressChange = useCallback(
    (data: ILocationResponsePayload) => {


      console.log(data, "<==========data");

      setValues((prev) => ({
        ...prev,

        service_state_v: data.state,


        area_v: data.area,

      }));
    },
    [setValues],
  );

  const fetchVehicleList = async () => {
    if (isFamilyPlan && auth.user && auth.user.tokens) {
      try {
        // setLoading(true);
        const res = await api.get(
          `/get-family-added-vehicles?membership_code_v=${selectedMemberShip.membership_code}`,
          {
            headers: {
              "auth-Token": auth.user.tokens.access,
            },
          }
        );
        setVehicleList(res.data.result);
      } catch (err: any) {
        // showTopErrorSnackbar(err.response.data.msg);
      } finally {
        // setLoading(false);
      }
    }
  };
  const handleStateChange = (event: any, newValue: IState | null) => {
    if (newValue) {
      setValues({
        ...values,
        service_state_v: newValue.state_name,
        // city_v: "",
        // area_v: "",
      });
      setAutoField({ ...autoField, state: newValue });
      // dispatch(fetchCityAsync(newValue.state_id));
    }
  };

  React.useEffect(() => {
    if (isFamilyPlan) {
      fetchVehicleList();
    }
    dispatch(fetchStateAsync());
  }, []);

  const handleOtherFault = (event: SelectChangeEvent<unknown>) => {
    const { value } = event.target;
    setFieldValue("sub_fault_v", value);
    setIsOtherFault(value === "Others");
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 3, mb: 1.5 }}>
        <CustomTypography variant="body1" sx={{ m: 0 }}>
          You have selected mobile number {selectedMobileNumber} and vechicle
          number {selectedVechileNumber}.
        </CustomTypography>
        {selectedMemberShip && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              p: 1,
              borderRadius: 1,
              backgroundColor: "action.hover",
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Expiry Date: <span style={{ fontWeight: 600, color: "#e53935" }}>{selectedMemberShip.membership_expiry_date ? formatDate(selectedMemberShip.membership_expiry_date) : "N/A"}</span>
            </Typography>
            <Box sx={{ borderLeft: "1px solid", borderColor: "divider", height: 16 }} />
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Services Remaining: <span style={{ fontWeight: 600, color: "#1e88e5" }}>{selectedMemberShip.remain_services || "0"}</span>
            </Typography>
          </Box>
        )}
      </Box>
      <Grid container spacing={1}>
        <Grid item xs={12} lg={4}>
          <CustomFormLabel>Membership Code</CustomFormLabel>
          <CustomTextField
            id="membership_id_v"
            variant="outlined"
            size="small"
            type="string"
            disabled
            fullWidth
            value={values.membership_id_v}
            // onChange={handleChange}
            error={errors.membership_id_v ? true : false}
            helperText={errors.membership_id_v}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <CustomFormLabel>Vechicle Number</CustomFormLabel>

          {isFamilyPlan ? (
            <CustomSelect
              name="vehicle_no_v"
              variant="outlined"
              size="small"
              type="string"
              id="vehicle_no_v"
              value={values.vehicle_no_v}
              onChange={handleChange}
              fullWidth
            >
              {values.vehicle_no_v && (
                <MenuItem value={values.vehicle_no_v}>
                  {values.vehicle_no_v}
                </MenuItem>
              )}

              {vehicleList.map((vehicle) => (
                <MenuItem key={vehicle.vehicle_no} value={vehicle.vehicle_no}>
                  {vehicle.vehicle_no}
                </MenuItem>
              ))}
            </CustomSelect>
          ) : (
            <CustomTextField
              id="vehicle_no_v"
              variant="outlined"
              size="small"
              type="string"
              disabled
              fullWidth
              value={values.vehicle_no_v}
              onChange={handleChange}
              error={errors.vehicle_no_v ? true : false}
              helperText={errors.vehicle_no_v}
            />
          )}
        </Grid>

        <Grid item xs={12} lg={4}>
          <CustomFormLabel>Register Contact Number</CustomFormLabel>
          <CustomTextField
            id="reg_contact_no_v"
            variant="outlined"
            size="small"
            type="string"
            disabled
            fullWidth
            value={values.reg_contact_no_v}
            // onChange={handleChange}
            error={errors.reg_contact_no_v ? true : false}
            helperText={errors.reg_contact_no_v}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <CustomFormLabel>Vechicle Type</CustomFormLabel>
          <CustomSelect
            id="vehicle_type_v"
            name="vehicle_type_v"
            variant="outlined"
            size="small"
            type="string"
            fullWidth
            value={values.vehicle_type_v}
            onChange={handleChange}
            error={errors.vehicle_type_v ? true : false}
          >
            <MenuItem value={"-1"}>Select Vehicle Type</MenuItem>
            <MenuItem value={"FOUR_WHEELER"}>Four Wheeler</MenuItem>
            <MenuItem value={"TWO_WHEELER"}>Two Wheeler</MenuItem>
          </CustomSelect>
        </Grid>
        <Grid item xs={12} lg={4}>
          <CustomFormLabel>Fault Type</CustomFormLabel>
          <CustomSelect
            id="fault_type_v"
            name="fault_type_v"
            variant="outlined"
            size="small"
            type="string"
            fullWidth
            value={values.fault_type_v}
            onChange={handleFaultType}
            error={errors.fault_type_v ? true : false}
          >
            <MenuItem value={"-1"}>Select Fault Type</MenuItem>
            {(faultType.list["FOUR_WHEELER"] || []).map((item) => {
              return <MenuItem value={item.value}>{item.label}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} lg={4}>
          <CustomFormLabel>Fault Name</CustomFormLabel>
          <CustomSelect
            id="fault_v"
            name="fault_v"
            variant="outlined"
            size="small"
            type="string"
            fullWidth
            value={values.fault_v}
            onChange={handleFaultName}
            error={errors.fault_v ? true : false}
          >
            <MenuItem value={"-1"}>Select Fault Name</MenuItem>
            {(
              faultName.list[vehicleType + "-" + values.fault_type_v] || []
            ).map((item) => {
              return <MenuItem value={item.value}>{item.label}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} lg={4}>
          <CustomFormLabel>Fault Sub Type</CustomFormLabel>
          <CustomSelect
            id="sub_fault_v"
            name="sub_fault_v"
            variant="outlined"
            size="small"
            type="string"
            fullWidth
            value={values.sub_fault_v}
            onChange={handleOtherFault}
            error={errors.fault_v ? true : false}
          >
            <MenuItem value={"-1"}>Select Subfault Name</MenuItem>
            <MenuItem value={"Others"}>Others</MenuItem>
            {(
              faultSubTypeName.list[
              vehicleType + "-" + values.fault_type_v + "-" + values.fault_v
              ] || []
            ).map((item) => {
              return <MenuItem value={item.value}>{item.label}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>

        {isOtherFault && (
          <Grid item xs={12} lg={4}>
            <CustomFormLabel>Sub Fault Type</CustomFormLabel>
            <CustomTextField
              id="other_sub_fault_v"
              variant="outlined"
              size="small"
              type="text"
              fullWidth
              value={values.other_sub_fault_v}
              onChange={handleChange}
              error={errors.sub_fault_v ? true : false}
              helperText={errors.sub_fault_v}
            />
          </Grid>
        )}

        {/* <Grid item xs={12} lg={4}>
          <CustomFormLabel>Search Location</CustomFormLabel>
          <LocationAutoComplete
            value={values.area_v}
            onLocationChange={handleCustomerAddressChange}

          />
        </Grid> */}

        <Grid item xs={12} lg={8}>
          <CustomFormLabel>Stuckup Location</CustomFormLabel>
          <CustomTextField
            id="stuckup_location_v"
            variant="outlined"
            size="small"
            type="string"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title="Pick location on map">
                    <IconButton
                      size="small"
                      onClick={() => setMapPickerOpen(true)}
                      aria-label="Open map picker"
                    >
                      <LocationOn color="primary" />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
            value={values.stuckup_location_v}
            onChange={handleChange}
            error={errors.stuckup_location_v ? true : false}
            helperText={errors.stuckup_location_v}
          />
        </Grid>

        <Grid item xs={12} lg={4}>
          <CustomFormLabel>State</CustomFormLabel>
          {values.service_state_v ? <CustomTextField
            id="service_state_v"
            variant="outlined"
            size="small"
            type="string"
            fullWidth
            value={values.service_state_v}
            onChange={handleChange}
            error={errors.service_state_v ? true : false}
            helperText={errors.service_state_v}
          /> :
            <Autocomplete
              disablePortal
              value={autoField.state}
              options={state.list}
              getOptionLabel={(item) => item.state_name}
              onChange={handleStateChange}
              renderInput={(params) => (
                <CustomTextField
                  {...params}
                  error={errors.service_state_v ? true : false}
                  helperText={errors.service_state_v}
                  // label="Select State"
                  size="small"
                  variant="outlined"
                />
              )}
            />}

        </Grid>
        <Grid item xs={12} lg={4}>
          <CustomFormLabel>City</CustomFormLabel>
          <CustomTextField
            id="package_city_v"
            variant="outlined"
            size="small"
            type="string"
            disabled
            fullWidth
            value={values.package_city_v}
            onChange={handleChange}
            error={errors.package_city_v ? true : false}
            helperText={errors.package_city_v}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <CustomFormLabel>Area</CustomFormLabel>
          <CustomTextField
            id="area_v"
            variant="outlined"
            size="small"
            type="string"
            disabled
            fullWidth
            value={values.area_v}
            onChange={handleChange}
            error={errors.area_v ? true : false}
            helperText={errors.area_v}
          />
        </Grid>

        <Grid item xs={12} lg={8}>
          <CustomFormLabel>Additional Address</CustomFormLabel>
          <CustomTextField
            id="complaint_address_v"
            variant="outlined"
            size="small"
            type="string"
            fullWidth

            value={values.complaint_address_v}
            onChange={handleChange}
            error={errors.complaint_address_v ? true : false}
            helperText={errors.complaint_address_v}
          />
        </Grid>


        <Grid item xs={12} lg={4}>
          <CustomFormLabel>Alternative Contact Number</CustomFormLabel>
          <CustomTextField
            id="alternate_contact_no_v"
            variant="outlined"
            size="small"
            type="number"
            fullWidth
            value={values.alternate_contact_no_v}
            // onChange={handleChange}
            onChange={handleAlternateMobileNumberChange}
            error={errors.alternate_contact_no_v ? true : false}
            helperText={errors.alternate_contact_no_v}
          />
        </Grid>


        <Grid item xs={12} lg={8}>
          <CustomFormLabel>Remarks</CustomFormLabel>
          <CustomTextField
            id="remark_v"
            variant="outlined"
            size="small"
            type="string"
            multiline
            rows={2}
            fullWidth
            value={values.remark_v}
            onChange={handleChange}
            error={errors.remark_v ? true : false}
            helperText={errors.remark_v}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <CustomFormLabel>Complaint Creation Image</CustomFormLabel>
          <FileUpload
            value={values.complaint_creation_image_v}
            onChange={handleFileUpload}
            onDelete={handleFileDelete}
            uniqueKey="complaint_creation_image_v"
          />
          {errors.complaint_creation_image_v && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
              {errors.complaint_creation_image_v}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} lg={3} />
        <Grid item xs={12} lg={3} />
        <Grid item xs={12} lg={3} />
        <Grid item xs={12} lg={3}>
          <Button
            fullWidth
            disabled={loading}
            variant="contained"
            type="submit"
          >
            Submit
          </Button>
        </Grid>
      </Grid>

      <MapPicker
        open={mapPickerOpen}
        onClose={() => setMapPickerOpen(false)}
        onHandleLocationSelect={handleMapPickerLocationSelect}
      />
    </form>
  );
};
